function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_584",
  "data-name": "Grupo 584",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_882",
  "data-name": "Caminho 882",
  d: "M83.844,132.467H69.62a.89.89,0,0,1-.888-.888V120.941a.889.889,0,0,1,.888-.888H83.844a.889.889,0,0,1,.888.888v10.637A.889.889,0,0,1,83.844,132.467Zm-14.223-11.7a.178.178,0,0,0-.178.178v10.637a.178.178,0,0,0,.178.178H83.844a.178.178,0,0,0,.178-.178V120.941a.178.178,0,0,0-.178-.178h-.365l-5.873,6.667a1.181,1.181,0,0,1-1.8,0l-5.873-6.667Zm1.381,0,5.337,6.2a.482.482,0,0,0,.735,0l5.4-6.2Z",
  transform: "translate(-68.732 -120.053)"
}));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12.414,
    viewBox: "0 0 16 12.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.25f9d9dd.svg";
export { ForwardRef as ReactComponent };